export default "__VITE_ASSET__VKMhOkBL__$_?react__"